export default "__VITE_ASSET__d437ba57__"